export default function Hero() {
  const hero = document.querySelector('.hero');

  if (!hero) return;

  function setHeroHeight() {
    hero.style.setProperty('--heroHeight', window.innerHeight * (0.01 * 10) + 'rem');
  }

  setHeroHeight();

  document.querySelector('.hero__scroll').addEventListener('click', () => 
    scroll({
      top: hero.nextElementSibling.offsetTop - 50,
      behavior: 'smooth'
    })
  );
};
